import React from "react";
import { FiUser, FiCalendar, FiActivity, FiBarChart2 } from "react-icons/fi";

interface ProfileTabsProps {
  activeTab: "profile" | "availability" | "services" | "advertisements";
  onTabChange: (
    tab: "profile" | "availability" | "services" | "advertisements",
  ) => void;
  children: React.ReactNode;
  showAdvertisements?: boolean;
}

export default function ProfileTabs({
  activeTab,
  onTabChange,
  children,
  showAdvertisements = true,
}: ProfileTabsProps) {
  return (
    <div className="rounded-lg border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      {/* Tabs */}
      <div className="flex overflow-x-auto border-b border-stroke bg-gray-50/50 dark:border-strokedark dark:bg-gray-900/20 scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-gray-700 sm:scrollbar-hide">
        <button
          onClick={() => onTabChange("profile")}
          className={`group relative flex flex-shrink-0 items-center justify-center gap-1.5 px-4 py-3 text-xs font-semibold transition-all min-h-[44px] sm:gap-2 sm:px-6 sm:py-4 sm:text-sm ${
            activeTab === "profile"
              ? "text-purple-600 dark:text-purple-400"
              : "text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-200"
          }`}
        >
          <FiUser
            className={`w-4 h-4 sm:w-[18px] sm:h-[18px] ${
              activeTab === "profile" ? "animate-pulse" : ""
            }`}
          />
          <span className="whitespace-nowrap">Dados</span>
          <span className="hidden sm:inline whitespace-nowrap">Pessoais</span>
          {activeTab === "profile" && (
            <div className="pointer-events-none absolute bottom-0 left-1 right-1 h-1 rounded-t-full bg-gradient-to-r from-purple-600 via-purple-500 to-pink-500 shadow-[0_0_0_1px_rgba(124,58,237,0.25)] sm:left-2 sm:right-2 sm:h-1.5 md:h-1"></div>
          )}
        </button>
        <button
          onClick={() => onTabChange("services")}
          className={`group relative flex flex-shrink-0 items-center justify-center gap-1.5 px-4 py-3 text-xs font-semibold transition-all min-h-[44px] sm:gap-2 sm:px-6 sm:py-4 sm:text-sm ${
            activeTab === "services"
              ? "text-purple-600 dark:text-purple-400"
              : "text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-200"
          }`}
        >
          <FiActivity
            className={`w-4 h-4 sm:w-[18px] sm:h-[18px] ${
              activeTab === "services" ? "animate-pulse" : ""
            }`}
          />
          <span className="whitespace-nowrap">Serviços</span>
          {activeTab === "services" && (
            <div className="pointer-events-none absolute bottom-0 left-1 right-1 h-1 rounded-t-full bg-gradient-to-r from-purple-600 via-purple-500 to-pink-500 shadow-[0_0_0_1px_rgba(124,58,237,0.25)] sm:left-2 sm:right-2 sm:h-1.5 md:h-1"></div>
          )}
        </button>
        <button
          onClick={() => onTabChange("availability")}
          className={`group relative flex flex-shrink-0 items-center justify-center gap-1.5 px-4 py-3 text-xs font-semibold transition-all min-h-[44px] sm:gap-2 sm:px-6 sm:py-4 sm:text-sm ${
            activeTab === "availability"
              ? "text-purple-600 dark:text-purple-400"
              : "text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-200"
          }`}
        >
          <FiCalendar
            className={`w-4 h-4 sm:w-[18px] sm:h-[18px] ${
              activeTab === "availability" ? "animate-pulse" : ""
            }`}
          />
          <span className="whitespace-nowrap">Agenda</span>
          {activeTab === "availability" && (
            <div className="pointer-events-none absolute bottom-0 left-1 right-1 h-1 rounded-t-full bg-gradient-to-r from-purple-600 via-purple-500 to-pink-500 shadow-[0_0_0_1px_rgba(124,58,237,0.25)] sm:left-2 sm:right-2 sm:h-1.5 md:h-1"></div>
          )}
        </button>
        {showAdvertisements && (
          <button
            onClick={() => onTabChange("advertisements")}
            className={`group relative flex flex-shrink-0 items-center justify-center gap-1.5 px-4 py-3 text-xs font-semibold transition-all min-h-[44px] sm:gap-2 sm:px-6 sm:py-4 sm:text-sm ${
              activeTab === "advertisements"
                ? "text-purple-600 dark:text-purple-400"
                : "text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-200"
            }`}
          >
            <FiBarChart2
              className={`w-4 h-4 sm:w-[18px] sm:h-[18px] ${
                activeTab === "advertisements" ? "animate-pulse" : ""
              }`}
            />
            <span className="whitespace-nowrap">Anúncios</span>
            {activeTab === "advertisements" && (
              <div className="pointer-events-none absolute bottom-0 left-1 right-1 h-1 rounded-t-full bg-gradient-to-r from-purple-600 via-purple-500 to-pink-500 shadow-[0_0_0_1px_rgba(124,58,237,0.25)] sm:left-2 sm:right-2 sm:h-1.5 md:h-1"></div>
            )}
          </button>
        )}
      </div>

      {/* Conteúdo das Tabs */}
      <div className="p-4 sm:p-6 md:p-7">{children}</div>
    </div>
  );
}
